import sharedDatasInstance from "../sharedDatas";
import {        
    useMutation,  
    useQuery  
} from "@1f/react-sdk";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";
import { mutation_update_item } from "../mutations/workspaceMutations";
import { query_workspace_getItem, query_workspace_searchItem } from "../query/workspaceQueries";
import { query_anagraficheIds_byFascicolo_Id } from "../query/anagraficaQueries";

export const WorkspaceApi = () => {
    const tenantId = sharedDatasInstance.getPropertyByName("tenantId");
    const loggedUserId = sharedDatasInstance.getPropertyByName("userId");
    const errorApiHelpers = apiErrorHelper();        
    const wsUpdateItem = useMutation(mutation_update_item, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });
    const wsGetItem = useQuery(
        query_workspace_getItem,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const wsSearchItem = useQuery(
        query_workspace_searchItem,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    //Ricerca dell'anagrafica per CF/PIVA
    const SearchItem =  async (cf) => {
        try {            
            let response = await wsSearchItem.fetch({
                ownerId: tenantId,
                itemId: cf,                
                userId: loggedUserId,
            })
            return response
        } catch (error) {            
            // Se il servizio è temporaneamente disabilitato (503), non lanciare errore
            if (error.originalError?.extensions?.internal?.response?.status === 503) {
                return null;
            }
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Errore durante la ricerca dell'anagrafica su workspace");
        }
    }
    const GetItem = async (workspaceId) => {
        try {
            let response = await wsGetItem.fetch({                
                workspaceId: workspaceId,
                userId: loggedUserId,
            })
            return response
        } catch (error) {
            // Se il servizio è temporaneamente disabilitato (503), non lanciare errore
            if (error.originalError?.extensions?.internal?.response?.status === 503) {
                return null;
            }
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Errore durante il recupero dell'anagrafica da workspace");
        }
    }
    //Salvataggio o aggiornamento dell'anagrafica (comprensiva di dati aml e offices)
    const UpdateItem = async (anagraficaId) => {
        try {
            let response = await wsUpdateItem.fetch({
                userId: loggedUserId,
                anagraficaId: anagraficaId,
            })
            return response
        } catch (error) {
            // Se il servizio è temporaneamente disabilitato (503), non lanciare errore
            if (error.originalError?.extensions?.internal?.response?.status === 503) {
                return null;
            }
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Errore durante l'aggiornamento dell'anagrafica su workspace");
        }
    }
    return {
        SearchItem,
        GetItem,
        UpdateItem,
    };
}

export default WorkspaceApi;